module.exports = __webpack_public_path__ + "static/media/Layer3.6e26193d.png";